// third-party
import { FormattedMessage } from 'react-intl';

// assets
import {
  ChromeOutlined,
  SettingFilled,
  AccountBookFilled,
  QuestionOutlined,
  FolderOpenFilled,
  HomeFilled,
  CalendarFilled,
  SaveFilled,
  BookFilled,
  BackwardFilled,
  SwitcherFilled,
  ShoppingFilled,
  GiftFilled,
  DashboardFilled,
  MoneyCollectFilled
} from '@ant-design/icons';
// type
import { NavItemType } from 'types/menu';
import {
  frontdeskSubModule,
  reservationsSubModule,
  backTrackSubModule,
  mainBarSubModule,
  poolBarSubModule,
  restaturantSubModule,
  housekeepingSubModule,
  recordsSubModule,
  settingsSubModule,
  storeSubModule,
  statisticsSubModule,
  accountsSubModule
} from './sub-modules/subModuleBreadCrumbs';

// icons
const icons = {
  ChromeOutlined,
  SettingFilled,
  AccountBookFilled,
  QuestionOutlined,
  FolderOpenFilled,
  SaveFilled,
  HomeFilled,
  BookFilled,
  CalendarFilled,
  ShoppingFilled,
  GiftFilled,
  MoneyCollectFilled,
  DashboardFilled
};
// const defaultNavLinks = ["Reservations", "Frontdesk", "House Keeping", "Main Bar", "Pool Bar", "Restaurant",
//   "Kitchen",
//   "Store",
//   // "Audit Reports",
//   "Records",
//   "Backtrack",
//   "Settings",
//   // "Statistics",
// ];

const linkIconAndModule = {
  Reservations: { icon: BookFilled, children: reservationsSubModule },
  Frontdesk: { icon: CalendarFilled, children: frontdeskSubModule },
  'House Keeping': { icon: HomeFilled, children: housekeepingSubModule },
  'Main Bar': { icon: ShoppingFilled, children: mainBarSubModule },
  'Pool Bar': { icon: GiftFilled, children: poolBarSubModule },
  Restaurant: { icon: AccountBookFilled, children: restaturantSubModule },
  // Nath commented the kitchen sidebar
  // Kitchen: { icon: SwitcherFilled, children: storeSubModule },
  Store: { icon: SaveFilled, children: storeSubModule },
  // "Audit Reports": {icon: , children: },
  Records: { icon: SwitcherFilled, children: recordsSubModule },
  Accounts: { icon: MoneyCollectFilled, children: accountsSubModule },
  Backtrack: { icon: BackwardFilled, children: backTrackSubModule },
  Statistics: { icon: DashboardFilled, children: statisticsSubModule },
  Settings: { icon: SettingFilled, children: settingsSubModule },
};

const moduleMenuHelper = () => {
  const moduleChildren = [] as any[];
  // eslint-disable-next-line array-callback-return
  Object.keys(linkIconAndModule).map((menu, index) => {
    const data = {
      id: menu.toLowerCase(),
      title: <FormattedMessage id={menu} />,
      url: `/${menu.toLowerCase().replaceAll(' ', '-')}`,
      type: 'collapse',
      breadcrumbs: true,
      children: (linkIconAndModule as any)[menu].children,
      icon: (linkIconAndModule as any)[menu].icon
    };
    moduleChildren.push(data);
  });
  const moduleChildrenAndDocs = [...moduleChildren, softwareDocs];
  return moduleChildrenAndDocs;
};

const softwareDocs = {
  id: 'documentation',
  title: <FormattedMessage id="documentation" />,
  type: 'item',
  url: 'https://channelpro.com/hotelpro-docs/',
  icon: icons.QuestionOutlined,
  external: true,
  target: true,
  chip: {
    label: 'gitbook',
    color: 'secondary',
    size: 'small'
  }
};
// const navItemChildren = moduleMenuHelper().push(softwareDocs);
// ==============================|| MENU ITEMS - SUPPORT ||============================== //

const other: NavItemType = {
  id: 'other',
  title: <FormattedMessage id="others" />,
  type: 'group',
  children: moduleMenuHelper()
};

export default other;
